<template>
  <b-modal
    :visible="value"
    title="Crear Solicitante"
    size="lg"
    hide-footer
    centered
    @change="modalChangeEvent"
  >

    <SolicitanteEnEncargoForm
      :data="formData"
      :errors="formErrors"
      @update="updateForm"
    />

    <div class="mt-4 text-right">
      <BfButton
        variant="secondary"
        class="mr-3"
        @click="modalChangeEvent(false)"
      >
        Cancelar
      </BfButton>
      <BfButton @click="saveFormData">
        Guardar y seleccionar para el encargo
      </BfButton>
    </div>
  </b-modal>
</template>

<script>
import SolicitanteEnEncargoForm from '@/components/FormGroups/SolicitanteEnEncargoForm';
import { applicantAPI } from '@/api';

export default {
  name: 'CreateApplicantModal',

  props: {
    formErrors: {
      type: Object,
    },

    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      formData: {},
    };
  },

  async created() {
    const { data } = await applicantAPI.preCreate();
    this.formData = data;
  },

  methods: {
    updateForm({ key, value }) {
      this.formData = {
        ...this.formData,
        [key]: value,
      };
    },

    modalChangeEvent(visible) {
      this.$emit('input', visible);
    },

    saveFormData() {
      this.$emit('save-data', this.formData);
    },
  },

  components: {
    SolicitanteEnEncargoForm,
  },
};
</script>
